import { render, staticRenderFns } from "./Copywriting.vue?vue&type=template&id=597abdc3&scoped=true&"
import script from "./Copywriting.vue?vue&type=script&lang=ts&"
export * from "./Copywriting.vue?vue&type=script&lang=ts&"
import style0 from "./Copywriting.vue?vue&type=style&index=0&id=597abdc3&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "597abdc3",
  null
  
)

export default component.exports